import { render, staticRenderFns } from "./ModalCreateOrganizationManualContent.vue?vue&type=template&id=81be873c&scoped=true"
import script from "./ModalCreateOrganizationManualContent.vue?vue&type=script&lang=js"
export * from "./ModalCreateOrganizationManualContent.vue?vue&type=script&lang=js"
import style0 from "../../../node_modules/vue-tel-input/dist/vue-tel-input.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81be873c",
  null
  
)

export default component.exports